import { createActions } from 'redux-actions';

import { UpdateMobileNumberAuthParams, RequestOtpCodeForMobileNumberParams } from '@apis/AuthApi';

import { FormValues } from './type';

export type UpdateMobileNumberPayload = UpdateMobileNumberAuthParams;
export type OtpCodeRequestPayload = RequestOtpCodeForMobileNumberParams;

export type State = {
  isSuccess: boolean;
  errors: FormValues;
};

export const {
  mobileNumberUpdate,
  mobileNumberUpdateSuccess,
  mobileNumberUpdateError,
  otpCodeRequest,
} = createActions(
  'MOBILE_NUMBER_UPDATE',
  'MOBILE_NUMBER_UPDATE_SUCCESS',
  'MOBILE_NUMBER_UPDATE_ERROR',
  'OTP_CODE_REQUEST',
  {
    prefix: 'MOBILE_NUMBER',
  },
);
